import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";

@Injectable()
export class DownloadService extends BaseService {
    constructor(http: HttpClient,
        private applicationSettings: ApplicationSettingsService,
        authService: AuthService,
        toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    /**
     * Gets country information for a particular country as a pdf
     * @param countryCode The country code to retrieve the information for
     */
    downloadCountryInformation(countryCode: String): Observable<any> {
        return super.getWithContentType(`${this.applicationSettings.apiUrl}download/downloadSummary/${countryCode}`
            , "application / octet - stream");
    }

    downloadCountryComparison(countryCodes: string[]): Observable<any> {
        let url: string = `${this.applicationSettings.apiUrl}download/downloadComparison/`;
        return super.postWithContentType(url, "application/json;charset=UTF-8", countryCodes);
    }
}